module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editContent":"Edit content","validate":"Validate"},"fr":{"editContent":"Contenu","validate":"Valider"},"de":{"editContent":"Inhalt","validate":"Bestätigen"}}')
  delete Component.options._Ctor
}
